// extracted by mini-css-extract-plugin
export var banner = "_rv-0";
export var settingRow = "_rv-2";
export var titleIcon = "_rv-1";